let prevScrollpos = 0;
let up = false;
let upStart = false;
let scrollStore = 0;

function repeatOften() {
  const navbar = document.getElementById('navbar');
  const currentScrollPos = window.scrollY;

  if (!navbar) {
    return;
  }

  if ((prevScrollpos >= currentScrollPos && up) || prevScrollpos === 0) {
    navbar.classList.remove('navbar--scrolled');
  } else if (currentScrollPos > 10) {
    navbar.classList.add('navbar--scrolled');
  }

  if (prevScrollpos > currentScrollPos) {
    if(!upStart) {
      scrollStore = currentScrollPos;
      upStart = true;
    }
    if(scrollStore - currentScrollPos > 20) {
      up = true;
    }
  }
  if (prevScrollpos < currentScrollPos || prevScrollpos === 0) {
    if(upStart) {
      scrollStore = currentScrollPos
      upStart = false;
    }
    if(currentScrollPos - scrollStore > 20 || prevScrollpos === 0) {
      up = false;
    }
  }

  if (currentScrollPos > 10 && up) {
    navbar.classList.add('navbar--up');
  } else if (!up) {
    navbar.classList.remove('navbar--up');
  }
  prevScrollpos = currentScrollPos > 0 ? currentScrollPos : 0;

  requestAnimationFrame(repeatOften);
}
requestAnimationFrame(repeatOften);
